import React from 'react';
import { Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@llt-frontend/react-material-progress';
import useAppContext from '../../hooks/context/use-app-context';
import { useGetQuotes } from './hooks';
import { ClassListItem } from './class-list-item';
import { PackageListItem } from './package-list-item';

export function QuotesList() {
  const { analyticsContext } = useAppContext();
  const {
    isLoading,
    isError,
    data: { classes, packages, subscriptions },
  } = useGetQuotes();

  const { t, ready: translationLoaded } = useTranslation('quotes/quotes-list');

  // track errors
  React.useEffect(() => {
    if (isError) {
      analyticsContext.trackEvent({
        action: 'quotes-fetch-failed',
        category: 'quotes',
      });
    }
  }, [isError, analyticsContext]);

  if (
    !isLoading &&
    !isError &&
    classes.length === 0 &&
    packages.length === 0 &&
    subscriptions.length === 0
  ) {
    return <Redirect to="/tutoring-packages" />;
  }

  return (
    <>
      {translationLoaded && (
        <div className="quotes-list">
          <div className="quotes-container">
            {isError && <div className="quotes-container__error">{t('fetchError')}</div>}
            {isLoading && (
              <div className="quotes-container__loading">
                <span>
                  <CircularProgress />
                </span>
              </div>
            )}
            {!isError && !isLoading && (
              <>
                <h5 className="quotes-list__headline">{t('headline')}</h5>
                <h5 className="quotes-list__subtitle">{t('subtitle')}</h5>
                {packages.length !== 0 && (
                  <>
                    <h6 className="quotes-list__label">{t('packageLabel')}</h6>
                    {packages.map(({ quote, item }) => (
                      <PackageListItem key={quote.id} quote={quote} item={item} />
                    ))}
                  </>
                )}
                {subscriptions.length !== 0 && (
                  <>
                    <h6 className="quotes-list__label">{t('subscriptionLabel')}</h6>
                    {subscriptions.map(({ quote, item }) => (
                      <ClassListItem key={quote.id} quote={quote} item={item} />
                    ))}
                  </>
                )}
                {classes.length !== 0 && (
                  <>
                    <h6 className="quotes-list__label">{t('classLabel')}</h6>
                    {classes.map(({ quote, item }) => (
                      <ClassListItem key={quote.id} quote={quote} item={item} />
                    ))}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default QuotesList;
